import humanizeDuration from "humanize-duration";
import { upperFirst, lowerCase } from "lodash";
import moment from "moment";

export const sentenceCase = (str: string) => upperFirst(lowerCase(str));

export function formatDurationInWords(duration: string | null): string {
    return duration ? humanizeDuration(moment.duration(duration).asMilliseconds(), { largest: 2, maxDecimalPoints: 0, round: true }) : "N/A";
}
